import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { copyTextToClipboard } from '@/helpers/copy-text-to-clipboard';
import { notify } from '@/ui/snackbar/notify';

export const COPY_RESET_MS = 1500;

interface UseMcpOAuthFieldCopyResult {
  copiedFieldId: string | null;
  copyValue: (value: string, fieldId: string) => Promise<void>;
}

export const useMcpOAuthFieldCopy = (): UseMcpOAuthFieldCopyResult => {
  const { t } = useTranslation('default');
  const [copiedFieldId, setCopiedFieldId] = useState<string | null>(null);
  const copyResetTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  useEffect(
    () => () => {
      if (copyResetTimeoutRef.current) {
        clearTimeout(copyResetTimeoutRef.current);
      }
    },
    [],
  );

  const copyValue = async (value: string, fieldId: string): Promise<void> => {
    try {
      await copyTextToClipboard(value);
      setCopiedFieldId(fieldId);

      if (copyResetTimeoutRef.current) {
        clearTimeout(copyResetTimeoutRef.current);
      }

      copyResetTimeoutRef.current = setTimeout(() => {
        setCopiedFieldId(current => (current === fieldId ? null : current));
      }, COPY_RESET_MS);
    } catch {
      notify({ message: t`unknownError` });
    }
  };

  return { copiedFieldId, copyValue };
};
